import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';

function Terms() {
  return (
    <>
      <section className="theme-light section m-0 p-0" data-theme="light">
        {/* Start flex container */}
          <div className='m-0 p-0 is-flex is-flex-direction-column is-justify-content-start'>

            {/* Navigation */}
            <div className='columns is-mobile is-flex is-flex-direction-rows is-justify-content-center'>
              <div className="m-0 p-0 column is-11"><Navigation /></div>
            </div>
            
            {/* Content */}
            <div className='pb-6 columns is-mobile is-flex is-flex-direction-rows is-justify-content-center main-content'>
              <div className="m-0 p-0 content column is-8 is-offset-4">
                <h1 className='py-4 m-0'>Terms of use</h1>
                
                <h4 className='py-1 m-0'>1. Acceptance of Terms </h4>
                <p>These Terms of Service ("Terms") govern your use of Nudgemail's website (the "Site") and services (the "Service"), including any content, materials, or information provided by Nudgemail (the "Content"). By accessing or using the Site, Content, or Service, you agree to be bound by these Terms. If you disagree, do not use the Site or Service.</p>

                <h4 className='py-1 m-0'>2. Account Types and Modifications </h4>
                <p>Nudgemail offers free and paid account tiers. Nudgemail reserves the right to modify these tiers, pricing structures, and feature sets with notice to active users. Continued use of the Service following modifications constitutes acceptance of the new terms.</p>

                <h4 className='py-1 m-0'>3. Nature of the Service and User Responsibilities </h4>
                <p className='pb-0 mb-0'>Nudgemail is an email reminder service where users provide their email addresses for future delivery of their messages. By using the Service, you agree to the following conditions:</p>
                <ul className='pt-0 mt-2'>
                    <li>Nudgemail does not guarantee continuous availability and may undergo maintenance or interruptions. Emails will be sent upon service restoration, but not stored beyond 90 days.</li>
                    <li>Nudgemail does not access user emails or share them with third parties.</li>
                    <li>Nudgemail may modify, suspend, or discontinue the Service and will notify active users accordingly.</li>
                    <li>Nudgemail reserves the right to refuse Service to anyone at any time.</li>
                </ul>

                <h4 className='py-1 m-0'>4. Acceptable Use Policy </h4>
                <p className='pb-0 mb-0'>Users must comply with all applicable local, state, national, and international laws. The following actions are prohibited:</p>
                <ul className='pt-0 mt-2'>
                    <li>Sending false, misleading, defamatory, obscene, or offensive content.</li>
                    <li>Promoting hate speech, discrimination, or illegal activities.</li>
                    <li>Attempting to hack, disrupt, or compromise Nudgemail's security.</li>
                    <li>Engaging in spamming, unsolicited promotions, or fraudulent activities.</li>
                </ul>

                <p>Nudgemail reserves the right to investigate and take legal action against violations, including cooperating with law enforcement.</p>

                <h4 className='py-1 m-0'>5. Age Restrictions</h4>
                <p>Nudgemail complies with the Children's Online Privacy Protection Act (COPPA). Users must be at least 13 years old to access the Service.</p>

                <h4 className='py-1 m-0'>6. Termination of Access</h4>
                <p>Nudgemail reserves the right to terminate user accounts for violations of these Terms. Free accounts may be terminated at any time without notice.</p>

                <h4 className='py-1 m-0'>7. Disclaimer of Warranties</h4>
                <p>Nudgemail is provided "as is" without warranties of any kind, including availability, security, or performance guarantees. Users assume all risks associated with using the Service.</p>

                <h4 className='py-1 m-0'>8. Limitation of Liability</h4>
                <p>Nudgemail is not liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use the Service, including data loss or service disruptions.</p>

                <h4 className='py-1 m-0'>9. Amendments</h4>
                <p>Nudgemail may update these Terms at any time. Continued use of the Service constitutes acceptance of the modified Terms.</p>

                <h4 className='py-1 m-0'>10. Contact Information</h4>
                <p>For questions regarding these Terms, contact Nudgemail at <a href="mailto:support@nudgemail.com" className='textLink'>support@nudgemail.com</a> or by visiting Nudgemail's Contact us page at <a href="https://nudgemail.com/contact" className='textLink'>https://nudgemail.com/contact</a>.</p>
              </div>
            </div> 
            
            {/* Footer */}
            <div className='footer m-0 p-0 columns is-mobile is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
              <div className="m-0 p-0 column is-11 is-10-mobile"><Footer /></div>
            </div>

          </div> 
          {/* End flex container */}
      </section>
    </>
  );
}

export default Terms;